/**
 * Traductions françaises
 * Fichier TypeScript pour le typage et l'autocomplétion
 */

export const fr = {
  common: {
    save: "Enregistrer",
    cancel: "Annuler",
    delete: "Supprimer",
    edit: "Modifier",
    close: "Fermer",
    confirm: "Confirmer",
    loading: "Chargement...",
    error: "Erreur",
    success: "Succès",
    yes: "Oui",
    no: "Non",
    back: "Retour",
    next: "Suivant",
    previous: "Précédent",
    search: "Rechercher",
    submit: "Soumettre"
  },
  nav: {
    home: "Accueil",
    courses: "Cours",
    webinars: "Webinaires",
    about: "À propos",
    faq: "FAQ",
    contact: "Contact",
    aySolutions: "AY Solutions",
    login: "Connexion",
    signup: "S'inscrire",
    logout: "Déconnexion",
    profile: "Mon profil",
    admin: "Administration",
    dashboard: "Dashboard",
    menu: "Menu"
  },
  auth: {
    email: "Email",
    password: "Mot de passe",
    confirmPassword: "Confirmer le mot de passe",
    forgotPassword: "Mot de passe oublié ?",
    rememberMe: "Se souvenir de moi",
    alreadyHaveAccount: "Vous avez déjà un compte ?",
    dontHaveAccount: "Vous n'avez pas de compte ?",
    resetPassword: "Réinitialiser le mot de passe",
    verifyEmail: "Vérifier l'email"
  },
  login: {
    studentsImageAlt: "Étudiants AY Solutions Academy",
    connectToAccessCourse: "Connectez-vous pour accéder au cours",
    createAccountOrLogin: "Créez un compte ou connectez-vous pour commencer votre apprentissage",
    welcomeBack: "Bon retour",
    pleaseLogin: "Veuillez vous connecter à votre compte",
    emailPlaceholder: "Email",
    passwordPlaceholder: "Mot de passe",
    forgotPassword: "Mot de passe oublié ?",
    connecting: "Connexion...",
    login: "Se connecter",
    noAccountYet: "Pas encore de compte ?",
    signup: "S'inscrire",
    forgotPasswordTitle: "Mot de passe oublié ?",
    enterEmailForReset: "Entrez votre email pour recevoir un lien de réinitialisation",
    yourEmail: "Votre email",
    cancel: "Annuler",
    sending: "Envoi...",
    send: "Envoyer",
    enterEmailAddress: "Veuillez entrer votre adresse email",
    resetEmailSent: "Email de réinitialisation envoyé à {{email}}",
    emailSendFailed: "Échec de l'envoi de l'email",
    loginError: "Erreur de connexion",
    free: "Gratuit",
    paidCourse: "Cours payant"
  },
  signup: {
    studentsImageAlt: "Étudiants AY Solutions Academy",
    createAccountToAccessCourse: "Créez un compte pour accéder au cours",
    signupNowToStart: "Inscrivez-vous maintenant pour commencer votre apprentissage",
    welcomeToAY: "Bienvenue sur AY",
    signup: "Inscrivez-vous",
    fullName: "Nom complet",
    emailPlaceholder: "Email",
    passwordPlaceholder: "Mot de passe",
    confirmPasswordPlaceholder: "Confirmer le mot de passe",
    phoneOptional: "Téléphone (optionnel)",
    addressOptional: "Adresse (optionnel)",
    cityOptional: "Ville (optionnel)",
    countryOptional: "Pays (optionnel)",
    signingUp: "Inscription...",
    signupButton: "S'inscrire",
    alreadyHaveAccount: "Vous avez déjà un compte ?",
    login: "Se connecter",
    signupError: "Erreur d'inscription",
    free: "Gratuit",
    paidCourse: "Cours payant"
  },
  course: {
    title: "Titre",
    description: "Description",
    content: "Contenu",
    enroll: "S'inscrire",
    start: "Commencer",
    continue: "Continuer",
    progress: "Progression",
    modules: "Modules",
    lessons: "Chapitres",
    quiz: "Quiz",
    assignment: "Devoir",
    download: "Télécharger"
  },
  admin: {
    dashboard: "Tableau de bord",
    users: "Utilisateurs",
    courses: "Cours",
    promoCodes: "Codes promo",
    payments: "Paiements",
    settings: "Paramètres",
    promoCode: {
      title: "Codes Promo",
      subtitle: "Gérer les codes promo de réduction",
      create: "Créer un code promo",
      edit: "Modifier le code promo",
      code: "Code",
      description: "Description",
      discount: "Réduction",
      period: "Période",
      uses: "Utilisations",
      status: "Statut",
      active: "Actif",
      inactive: "Inactif",
      expired: "Expiré",
      search: "Rechercher un code promo...",
      noPromoCodes: "Aucun code promo trouvé",
      deleteConfirm: "Êtes-vous sûr de vouloir supprimer le code promo \"{{code}}\" ?",
      deleteSuccess: "Code promo supprimé avec succès",
      toggleSuccess: "Code promo {{status}} avec succès"
    },
    courseEnrollments: {
      title: "Gestion des Utilisateurs de Cours",
      subtitle: "Gérer les inscriptions et accès aux cours",
      selectCourse: "Sélectionner un cours",
      selectCoursePlaceholder: "-- Sélectionner un cours --",
      noCourseSelected: "Sélectionnez un cours pour voir ses utilisateurs",
      search: "Rechercher un utilisateur...",
      status: "Statut",
      enrolled: "Inscrit",
      inProgress: "En cours",
      completed: "Terminé",
      dropped: "Abandonné",
      blocked: "Bloqué",
      enrolledAt: "Inscrit le",
      expiresAt: "Expire le",
      activateForUsers: "Activer pour utilisateurs",
      noUsers: "Aucun utilisateur trouvé",
      deleteConfirm: "Êtes-vous sûr de vouloir retirer {{name}} du cours ?",
      deleteSuccess: "Utilisateur retiré du cours avec succès",
      unblockSuccess: "Accès débloqué avec succès",
      blockSuccess: "Accès bloqué avec succès",
      updateAccessSuccess: "Accès mis à jour avec succès"
    },
    categories: {
      title: "Gestion des Catégories",
      subtitle: "Créer, modifier et gérer les catégories de cours",
      create: "Créer une catégorie",
      edit: "Modifier la catégorie",
      name: "Nom",
      description: "Description",
      icon: "Icône",
      color: "Couleur",
      courseCount: "Nombre de cours",
      search: "Rechercher une catégorie...",
      noCategories: "Aucune catégorie trouvée",
      deleteConfirm: "Êtes-vous sûr de vouloir supprimer la catégorie \"{{name}}\" ?",
      deleteSuccess: "Catégorie supprimée avec succès",
      manageTranslations: "Gérer les traductions",
      translations: "Traductions"
    }
  },
  home: {
    marqueeDiscount: "Réduction de 20% sur tous nos cours jusqu'au 31 décembre !",
    marqueeCourses: "Plus de 500 cours disponibles",
    marqueeSatisfaction: "98% de satisfaction client",
    marqueeCertificates: "Certificats reconnus par les employeurs",
    marqueeLearn: "Apprenez depuis n'importe où",
    marqueePractical: "Formations pratiques et à jour",
    marqueeInstructors: "Instructeurs experts",
    marqueeLifetime: "Accès fermé après 6 mois d'inscription au module",
    newLearningPlatform: "🎓 Nouvelle plateforme d'apprentissage",
    learnSkills: "Apprenez les compétences de",
    tomorrow: "demain",
    heroDescription: "Découvrez des cours en ligne de qualité, créés par des experts. Développez vos compétences à votre rythme, où que vous soyez.",
    searchPlaceholder: "Rechercher un cours...",
    exploreCourses: "Explorer les cours",
    qualityCourses: "Cours de qualité",
    certificatesIncluded: "Certificats inclus",
    atYourPace: "À votre rythme",
    studentsOnline: "Étudiants en ligne",
    howItWorks: "Comment ça marche ?",
    howItWorksSubtitle: "Commencez votre apprentissage en 3 étapes simples",
    step1Title: "Choisissez votre cours",
    step1Description: "Parcourez notre catalogue et sélectionnez le cours qui vous intéresse",
    step2Title: "Apprenez à votre rythme",
    step2Description: "Suivez les chapitres vidéo, faites les exercices et progressez étape par étape",
    step3Title: "Obtenez votre certificat",
    step3Description: "Validez vos acquis et recevez votre certificat de réussite",
    whyChooseUs: "Pourquoi choisir AY Solutions Academy ?",
    whyChooseUsSubtitle: "Une plateforme pensée pour votre réussite",
    coursesAvailable: "Cours disponibles",
    available24h: "24h/24",
    onlineStudent: "Étudiante en formation en ligne",
    recognizedCertifications: "Certifications reconnues",
    recognizedCertificationsDesc: "À la fin de chaque formation, vous obtenez un certificat attestant vos compétences, valorisable sur votre CV ou LinkedIn.",
    totalFlexibility: "Flexibilité totale",
    totalFlexibilityDesc: "Apprenez où vous voulez et quand vous voulez, sans contrainte d'emploi du temps.",
    qualifiedTrainers: "Formateurs qualifiés",
    qualifiedTrainersDesc: "Tous nos cours sont animés par des experts et professionnels, avec une pédagogie claire et adaptée à tous les niveaux.",
    interactiveLearning: "Apprentissage interactif et à jour",
    interactiveLearningDesc: "Cours régulièrement mis à jour, avec quiz, exercices pratiques et études de cas pour appliquer immédiatement vos connaissances.",
    discoverPrograms: "Découvrez nos programmes",
    discoverProgramsSubtitle: "Un aperçu de notre catalogue de formations",
    viewAllCourses: "Voir tous les modules",
    loadingCourses: "Chargement des cours...",
    noPopularCourses: "Aucun cours populaire disponible",
    noPopularCoursesDesc: "Les cours seront bientôt disponibles.",
    recommendedForYou: "Nos programmes de formations",
    recommendedForYouSubtitle: "Des modules sélectionnés selon vos intérêts",
    noRecommendedCourses: "Aucun cours recommandé disponible",
    noRecommendedCoursesDesc: "Les cours seront bientôt disponibles.",
    testimonials: "Témoignages",
    testimonialsSubtitle: "Découvrez ce que nos étudiants disent de leur expérience",
    testimonial1Name: "Marie Kouassi",
    testimonial1Role: "Développeuse Web",
    testimonial1Text: "AY Solutions Academy a transformé ma carrière. Les cours sont bien structurés et les formateurs sont excellents. J'ai pu obtenir un poste de développeuse grâce aux compétences acquises ici.",
    testimonial2Name: "Jean Traoré",
    testimonial2Role: "Analyste de données",
    testimonial2Text: "Une plateforme exceptionnelle ! La flexibilité d'apprendre à mon rythme et la qualité des contenus m'ont permis de progresser rapidement. Je recommande vivement.",
    testimonial3Name: "Aminata Diallo",
    testimonial3Role: "Chef de projet",
    testimonial3Text: "Les certificats obtenus sur AY Solutions Academy sont reconnus par mon employeur. L'apprentissage pratique et les cas réels m'ont beaucoup aidée dans mon travail quotidien."
  },
  about: {
    title: "À propos d'AY Solutions Academy",
    subtitle: "Nous révolutionnons l'éducation en ligne en Afrique en rendant l'apprentissage accessible, engageant et adapté aux réalités de notre continent.",
    ourStory: "Notre histoire",
    ourStoryText1: "AY Solutions Academy a été fondé en 2026 par AY SOLUTIONS, exploitant son expertise reconnue en innovation numérique et conseil.",
    ourStoryText2: "La plateforme est née d'une conviction stratégique : utiliser la technologie pour démocratiser l'éducation de qualité en brisant les contraintes géographiques.",
    ourStoryText3: "Depuis son lancement, notre évolution est marquée par la concentration sur l'expérience utilisateur et l'excellence pédagogique, visant à autonomiser les étudiants et à les préparer efficacement aux défis du marché du travail de demain.",
    ourVision: "Notre vision",
    ourVisionText1: "Devenir la référence africaine de l'enseignement en ligne, en mesurant notre succès à l'impact direct et réel sur la progression de carrière de nos apprenants.",
    ourVisionText2: "Nous œuvrons pour un écosystème d'apprentissage dynamique, intelligent et hautement personnalisé, fortement alimenté par l'Intelligence Artificielle (IA). Cette approche vise à redéfinir l'e-learning, offrant une richesse pédagogique comparable à un apprentissage en présentiel tout en conservant une flexibilité totale.",
    statsTitle: "Nos résultats en chiffres",
    statsSubtitle: "L'impact de notre plateforme sur l'éducation en Afrique",
    activeStudents: "Étudiants actifs",
    availableCourses: "Cours disponibles",
    expertTrainers: "Formateurs experts",
    satisfactionRate: "Taux de satisfaction",
    goals2025: "Nos objectifs pour 2026",
    goalsSubtitle: "Des engagements concrets pour faire grandir notre communauté et renforcer l'impact de nos formations.",
    goal1Title: "1. Expansion du catalogue",
    goal1Desc: "Intégrer au moins 20 nouveaux programmes certifiants, avec un focus particulier sur la Cybersécurité et la Data Science, afin d'anticiper les besoins du marché.",
    goal2Title: "2. Croissance de la communauté",
    goal2Desc: "Atteindre 100 000 apprenants actifs sur la plateforme pour consolider notre leadership régional et favoriser les échanges entre pairs.",
    goal3Title: "3. Amélioration technologique",
    goal3Desc: "Lancer l'application mobile V2 pour offrir une expérience complète et fluide, y compris l'apprentissage hors ligne et des notifications intelligentes.",
    goal4Title: "4. Succès des apprenants",
    goal4Desc: "Maintenir un taux de complétion de 80 % en renforçant le tutorat personnalisé, les sessions de coaching carrière et les ressources d'accompagnement.",
    goal5Title: "5. Reconnaissance",
    goal5Desc: "Obtenir une certification qualité internationale pour valider nos méthodologies pédagogiques et garantir un niveau d'exigence constant.",
    valuesTitle: "Nos valeurs",
    valuesSubtitle: "Les principes qui guident notre mission et façonnent chaque aspect de notre plateforme",
    academicExcellence: "Excellence académique",
    academicExcellenceDesc: "Nous nous engageons à fournir une éducation de la plus haute qualité, avec des contenus rigoureusement sélectionnés et mis à jour régulièrement.",
    accessibilityForAll: "Accessibilité pour tous",
    accessibilityForAllDesc: "L'éducation doit être accessible à tous, peu importe le lieu, l'heure ou les moyens financiers. C'est pourquoi nous proposons des cours gratuits et abordables.",
    techInnovation: "Innovation technologique",
    techInnovationDesc: "Nous utilisons les dernières technologies pour créer des expériences d'apprentissage interactives et engageantes qui s'adaptent à vos besoins.",
    practicalLearning: "Apprentissage pratique",
    practicalLearningDesc: "Nos cours sont conçus pour être appliqués immédiatement dans le monde réel, avec des projets concrets et des cas d'usage pratiques.",
    teamTitle: "Notre équipe",
    teamSubtitle: "Des professionnels passionnés qui œuvrent chaque jour pour améliorer votre expérience d'apprentissage",
    joinMission: "Rejoignez notre mission",
    joinMissionText: "Ensemble, construisons l'avenir de l'éducation en Afrique. Votre parcours d'apprentissage commence ici.",
    discoverCourses: "Découvrir nos cours",
    contactUs: "Nous contacter"
  },
  contact: {
    title: "Contactez-nous",
    subtitle: "Nous sommes là pour vous aider. N'hésitez pas à nous contacter pour toute question ou assistance.",
    email: "Email",
    sendEmail: "Envoyez-nous un email",
    phone: "Téléphone",
    address: "Adresse",
    hours: "Horaires",
    mondayToFriday: "Lundi au Vendredi",
    sendMessage: "Envoyez-nous un message",
    sendMessageDesc: "Remplissez le formulaire ci-dessous et nous vous répondrons rapidement.",
    fullName: "Nom complet",
    fullNamePlaceholder: "Votre nom",
    emailPlaceholder: "votre@email.com",
    subject: "Sujet",
    subjectPlaceholder: "Sujet de votre message",
    message: "Message",
    messagePlaceholder: "Décrivez votre demande en détail...",
    sending: "Envoi en cours...",
    sendButton: "Envoyer le message",
    messageSent: "Message envoyé avec succès ! Nous vous répondrons dans les plus brefs délais.",
    quickSolutions: "Solutions rapides",
    quickSolutionsDesc: "Besoin d'une aide immédiate ? Essayez ces options.",
    liveChat: "Chat en direct",
    liveChatDesc: "Obtenez une réponse instantanée",
    startChat: "Démarrer le chat",
    techSupport: "Support technique",
    techSupportDesc: "Aide pour vos cours",
    contactSupport: "Contacter le support",
    faq: "FAQ",
    faqDesc: "Questions fréquentes",
    viewFAQ: "Consulter la FAQ",
    frequentQuestions: "Questions fréquentes",
    faqSubtitle: "Trouvez rapidement des réponses à vos questions.",
    faq1Question: "Comment puis-je récupérer mon mot de passe ?",
    faq1Answer: "Utilisez le lien \"Mot de passe oublié\" sur la page de connexion.",
    faq2Question: "Comment accéder à mes cours ?",
    faq2Answer: "Connectez-vous et allez dans la section \"Mes cours\" de votre profil.",
    faq3Question: "Problème technique avec une vidéo ?",
    faq3Answer: "Vérifiez votre connexion internet et actualisez la page.",
    viewAllFAQ: "Voir toutes les FAQ",
    ourLocation: "Notre localisation",
    locationSubtitle: "Venez nous rendre visite dans nos bureaux",
    interactiveMap: "Carte interactive"
  },
  courses: {
    title: "Découvrez nos programmes",
    subtitle: "Plus de 50 cours créés par des experts pour développer vos compétences",
    searchPlaceholder: "Rechercher un cours, une catégorie...",
    all: "Tous",
    loading: "Chargement des cours...",
    errorTitle: "Erreur de chargement",
    errorMessage: "Une erreur est survenue",
    coursesAvailable: "cours disponibles",
    coursesIn: "cours en",
    sortBy: "Trier par",
    popularity: "Populaire",
    recent: "Récent",
    oldest: "Ancien",
    noCoursesFound: "Aucun cours trouvé",
    noCoursesFoundDesc: "Essayez de modifier vos critères de recherche ou de filtrage."
  },
  courseDetail: {
    loading: "Chargement du cours...",
    errorTitle: "Erreur de chargement",
    errorMessage: "Une erreur est survenue",
    backToCourses: "Retour aux cours",
    courseNotFound: "Cours introuvable",
    courseNotFoundDesc: "Le cours demandé n'existe pas ou n'est plus disponible.",
    category: "Catégorie",
    beginner: "Débutant",
    intermediate: "Intermédiaire",
    advanced: "Avancé",
    reviews: "avis",
    students: "étudiants",
    lessons: "chapitres",
    instructor: "Instructeur",
    description: "Description",
    myProgress: "Ma progression",
    completed: "Terminé",
    inProgress: "En cours",
    globalProgress: "Progression globale",
    completedLessons: "Chapitres complétés",
    completedModules: "Modules complétés",
    completedQuizzes: "Quiz complétés",
    passingScore: "Score requis",
    available: "Disponible",
    lastVisit: "Dernière visite:",
    enrolledOn: "Inscrit le:",
    moduleDetails: "Détails des modules",
    modules: "modules",
    noModulesAvailable: "Aucun module disponible pour ce cours.",
    progression: "Progression:",
    blocks: "blocs",
    lessonsTitle: "Chapitres",
    startModule: "Commencer le module",
    continueModule: "Continuer le module",
    takeQuiz: "Passer au quiz",
    retakeQuiz: "Reprendre le quiz",
    retakeQuizButton: "Refaire le quiz",
    enrollInCourse: "S'inscrire au cours",
    startCourse: "Commencer le cours",
    continueCourse: "Continuer le cours",
    accessExpired: "Accès expiré",
    accessExpiredDesc: "Votre période d'accès à ce cours a expiré",
    expiredOn: "Expiré le",
    renewAccess: "Renouveler l'accès",
    certificateIssued: "Certificat délivré",
    certificateIssuedDesc: "Félicitations ! Vous avez terminé ce cours et obtenu votre certificat.",
    viewCertificate: "Voir le certificat",
    coursePrice: "Prix du cours",
    free: "Gratuit",
    enrollNow: "S'inscrire maintenant",
    mustBeEnrolled: "Vous devez être enrôlé au cours pour commencer",
    enrollmentError: "Erreur lors du démarrage du cours",
    enrollmentSuccess: "Inscription réussie !",
    youMustBeEnrolled: "Vous devez être enrôlé au cours pour commencer",
    congratulations: "Félicitations !",
    certificateObtained: "Vous avez obtenu votre certificat",
    viewMyCertificate: "Voir mon certificat",
    yourProgress: "Votre progression",
    lessonsCompleted: "chapitres complétés sur",
    starting: "Démarrage...",
    lifetimeAccess: "Accès fermé après 6 mois d'inscription au module",
    completionCertificate: "Certificat de completion",
    youAreEnrolled: "Vous êtes inscrit à ce cours",
    accessUntil: "Accès jusqu'au",
    courseCompleted: "Cours terminé avec succès",
    completedOn: "Terminé le",
    enrollmentInfo: "Informations d'inscription",
    status: "Statut",
    enrolled: "Inscrit",
    completedStatus: "Terminé",
    enrolledOnDate: "Inscrit le:",
    courseInfo: "Informations du cours",
    availableLanguages: "Langues disponibles: ",
    lastUpdate: "Dernière mise à jour: ",
    certificateIncluded: "Certificat inclus",
    loginToAccess: "Connectez-vous pour accéder à ce cours",
    createAccountOrLogin: "Créez un compte ou connectez-vous pour commencer votre apprentissage",
    fullCourseAccess: "Accès complet au contenu du cours",
    trackProgress: "Suivez votre progression",
    createAccount: "Créer un compte",
    alreadyHaveAccount: "J'ai déjà un compte",
    termsAndConditions: "En continuant, vous acceptez nos conditions d'utilisation",
    completedOnDate: "Terminé le: ",
    expiredOnDate: "Expire le: "
  },
  courseReader: {
    mustValidatePreviousQuiz: "Vous devez valider le quiz du module précédent pour accéder à ce module",
    moduleUnlocked: "Module \"{{title}}\" débloqué ! Vous pouvez y accéder maintenant.",
    mustValidateModuleQuiz: "Vous devez valider le quiz du module \"{{title}}\" avant de pouvoir passer ce quiz.",
    mustCompletePreviousModules: "Vous devez compléter tous les modules précédents avant de pouvoir passer ce quiz.",
    contentNotAvailable: "Contenu non disponible pour ce bloc.",
    loading: "Chargement en cours...",
    unsupportedContentType: "Type de contenu non supporté: {{type}}",
    loadingContent: "Chargement du contenu...",
    errorTitle: "Erreur de chargement",
    errorMessage: "Une erreur est survenue",
    backToCourse: "Retour au cours",
    moduleLocked: "Module verrouillé",
    moduleLockedDesc: "Ce module est verrouillé",
    goToPreviousModule: "Aller au module précédent",
    noContentAvailable: "Aucun contenu disponible",
    noContentDesc: "Ce module ne contient pas encore de contenu.",
    moduleContent: "Contenu du module",
    moduleOf: "Module {{current}} sur {{total}}",
    courseModules: "Modules du cours",
    passed: "passé",
    score: "Score: {{score}}%",
    locked: "Verrouillé",
    moduleProgress: "Progression du module",
    quiz: "Quiz",
    passedQuiz: "✓ Réussi",
    bestScore: "Meilleur: {{score}}%",
    notAttempted: "Non tenté",
    available: "Disponible",
    attempts: "tentative",
    attemptsPlural: "tentatives",
    canRetake: "• Peut repasser",
    mustCompleteAllBlocks: "Vous devez compléter tous les blocs du module avant de pouvoir passer le quiz.",
    completePreviousModules: "Complétez tous les modules précédents pour accéder au quiz",
    completeAllBlocks: "Complétez tous les blocs pour accéder au quiz",
    viewQuiz: "Voir le quiz",
    retakeQuiz: "Repasser le quiz",
    takeQuiz: "Passer le quiz",
    quizLocked: "Quiz verrouillé",
    previous: "Précédent",
    markAsCompleted: "Marquer comme terminé",
    loadingNav: "Chargement...",
    goToQuiz: "Passer au quiz",
    nextModule: "Module suivant",
    finish: "Terminer",
    next: "Suivant"
  },
  quiz: {
    certificateMissing: "Certificat manquant",
    certificateIdMissing: "ID du certificat manquant",
    invalidBlob: "La réponse n'est pas un Blob valide",
    invalidFile: "La réponse n'est pas un fichier valide",
    emptyFile: "Le fichier téléchargé est vide",
    downloadSuccess: "Certificat téléchargé avec succès",
    downloadError: "Erreur lors du téléchargement du certificat",
    attemptCancelled: "Votre tentative de quiz a été annulée. Vous pouvez recommencer.",
    leavingWarning: "Vous êtes en train de passer un quiz. Si vous quittez maintenant, votre tentative sera annulée et vous perdrez une tentative.",
    leavingConfirm: "Vous êtes en train de passer un quiz. Si vous quittez maintenant, votre tentative sera annulée et vous perdrez une tentative. Voulez-vous vraiment quitter ?",
    noAnswer: "Aucune réponse",
    quizTitle: "Quiz",
    quizOfModule: "Quiz du Module",
    moduleLocked: "Module verrouillé",
    moduleLockedDesc: "Ce module est verrouillé",
    goToPreviousModule: "Aller au module précédent",
    backToCourse: "Retour au cours",
    quizAlreadyPassed: "Quiz déjà réussi",
    quizAlreadyPassedDesc: "Vous avez déjà validé ce quiz avec succès. Vous ne pouvez plus le repasser.",
    bestScore: "Meilleur score :",
    attemptsCount: "Nombre de tentatives :",
    backToCourseButton: "Retour sur le cours",
    quizLocked: "Quiz verrouillé",
    mustCompleteAllBlocks: "Vous devez compléter tous les blocs du module avant de pouvoir passer le quiz.",
    mustValidateModuleQuiz: "Vous devez valider le quiz du module \"{{title}}\" avant de pouvoir passer ce quiz.",
    mustCompletePreviousModules: "Vous devez compléter tous les modules précédents avant de pouvoir passer ce quiz.",
    backToModule: "Retour au module",
    loadingQuiz: "Chargement du quiz...",
    errorTitle: "Erreur de chargement",
    errorMessage: "Une erreur est survenue lors du chargement du quiz.",
    noQuizAvailable: "Aucun quiz disponible",
    noQuizDesc: "Ce module n'a pas de quiz associé.",
    questionOf: "Question {{current}} sur {{total}}",
    questionNumber: "Question {{number}}",
    questions: "Questions",
    minutes: "Minutes",
    requiredScore: "Score requis: {{score}}%",
    maxAttempts: "Tentatives max: {{attempts}}",
    instructions: "Instructions",
    startQuiz: "Commencer le quiz",
    requiredQuestion: "Question obligatoire",
    previous: "Précédent",
    submitting: "Soumission...",
    finishQuiz: "Terminer le quiz",
    next: "Suivant",
    submittingTitle: "Soumission en cours...",
    submittingDesc: "Veuillez patienter pendant que nous évaluons vos réponses.",
    results: "Résultats",
    maxAttemptsReached: "Vous avez atteint le nombre maximum de tentatives autorisées.",
    congratulations: "Félicitations ! Vous avez réussi le quiz.",
    scoreNotReached: "Vous n'avez pas atteint le score requis.",
    quizNotSubmitted: "Quiz non soumis :",
    attemptsExhausted: "❌ Tentatives épuisées",
    yourScore: "Votre score :",
    passed: "Réussi",
    failed: "❌ Échoué",
    requiredScoreLabel: "Score requis: {{score}}%",
    timeSpent: "Temps passé",
    attempt: "Tentative",
    remaining: "Restantes",
    pointsObtained: "Points obtenus",
    correctAnswers: "Bonnes réponses",
    errors: "Erreurs",
    congratulationsCertificate: "Félicitations ! Certificat obtenu !",
    completionCertificate: "Certificat de Completion",
    courseCompleted: "Cours terminé",
    certificateNumber: "Numéro de certificat:",
    issuedOn: "Délivré le",
    viewMyCertificates: "Voir mes certificats",
    downloadPDF: "Télécharger le PDF",
    certificateProgress: "Progression vers le certificat",
    eligibleForCertificate: "Vous êtes éligible pour le certificat !",
    completeAllModules: "Terminez tous les modules pour obtenir votre certificat.",
    completedModules: "Modules complétés: {{completed}} / {{total}}",
    remainingModules: "Modules restants: {{count}}",
    modulesRemaining: "Il vous reste {{count}} module(s) à compléter pour obtenir votre certificat.",
    quizzesToRetake: "Quiz à repasser: {{count}}",
    mustRetakeQuizzes: "Vous devez repasser certains quiz pour obtenir votre certificat.",
    attemptsExhaustedTitle: "Tentatives épuisées",
    messages: "Messages",
    cannotRetake: "Vous ne pouvez plus reprendre ce quiz. Contactez votre instructeur si nécessaire.",
    reviewAnswers: "Révision des réponses",
    reviewDesc: "Détail de vos réponses question par question",
    yourAnswer: "Votre réponse:",
    type: "Type:",
    timeSpentLabel: "Temps passé:",
    submissionError: "Erreur de soumission",
    submissionErrorDesc: "Une erreur est survenue lors de la soumission. Le score affiché est calculé localement.",
    continueToNextModule: "Continuer vers le module suivant : {{title}}",
    continueCourse: "Continuer le cours",
    retakeQuiz: "Reprendre le quiz ({{remaining}} tentatives restantes)",
    retakeQuizUnlimited: "Retourner au contenu du cours",
    maxAttemptsReachedTitle: "Nombre maximum de tentatives atteint",
    allAttemptsUsed: "Vous avez utilisé toutes vos tentatives ({{max}}) pour ce quiz.",
    contactInstructor: "Contactez votre instructeur si vous avez besoin d'aide.",
    congratulationsTitle: "Félicitations !",
    courseCompletedWithCertificate: "Vous avez terminé le cours et obtenu votre certificat !",
    allModulesCompleted: "Vous avez terminé tous les modules du cours !",
    writeAnswerHere: "Écrivez votre réponse ici...",
    manuallyEvaluated: "Cette question sera évaluée manuellement par l'instructeur.",
    unsupportedQuestionType: "Type de question non supporté",
    courseCompletedMessage: "Félicitations ! Vous avez terminé le cours et obtenu votre certificat !",
    allModulesCompletedMessage: "Félicitations ! Vous avez terminé tous les modules du cours !",
    excellentWork: "Excellent travail ! Passez au module suivant : \"{{title}}\"",
    quizValidated: "Quiz validé ! Le module suivant est maintenant accessible.",
    maxAttemptsError: "Nombre maximum de tentatives atteint",
    quizOfModuleTitle: "Quiz - {{title}}",
    returnToCoursesList: "Retournez à la liste des cours pour voir votre progression.",
    ongoingAttempt: "Une tentative est en cours",
    resumeQuiz: "Reprendre le quiz",
    startedAt: "Démarrée le",
    evaluateCourse: "Évaluer le cours"
  },
  courseReview: {
    title: "Évaluer le cours",
    courseTitle: "Cours :",
    ratingLabel: "Note (optionnel)",
    commentLabel: "Commentaire (optionnel)",
    commentPlaceholder: "Partagez votre expérience avec ce cours...",
    commentHint: "Votre commentaire sera visible par les autres étudiants",
    requiredMessage: "Vous devez évaluer ce cours avant de pouvoir télécharger votre certificat.",
    ratingOrCommentRequired: "Veuillez donner une note ou laisser un commentaire",
    commentTooLong: "Le commentaire ne peut pas dépasser 2000 caractères",
    reviewSubmitted: "Votre évaluation a été enregistrée avec succès !",
    submitError: "Une erreur est survenue lors de l'enregistrement de votre évaluation",
    cancel: "Annuler",
    submit: "Envoyer l'évaluation",
    submitting: "Envoi..."
  },
  certificate: {
    certificate: "Certificat",
    certified: "Certifié",
    preview: "Aperçu",
    download: "Télécharger",
    certificatePreview: "Aperçu du certificat",
    completionCertificate: "Certificat de complétion",
    certificateNumber: "Numéro de certificat",
    issuedOn: "Délivré le",
    certificateIdMissing: "ID du certificat manquant",
    invalidFile: "Fichier invalide",
    emptyFile: "Fichier vide",
    downloadSuccess: "Téléchargement lancé avec succès",
    downloadError: "Une erreur est survenue lors du téléchargement",
    evaluationRequired: "Vous devez évaluer le cours avant de télécharger le certificat"
  },
  profile: {
    loadingProfile: "Chargement du profil...",
    profile: "Profil",
    password: "Mot de passe",
    courses: "Mes cours",
    achievements: "Certificats",
    notifications: "Notifications",
    settings: "Paramètres",
    administration: "Administration",
    student: "Étudiant",
    administrator: "Administrateur",
    enrolledCourses: "cours inscrits",
    adminAccess: "Accès administrateur",
    cancel: "Annuler",
    saving: "Sauvegarde...",
    save: "Sauvegarder",
    edit: "Modifier",
    logout: "Déconnexion",
    personalInformation: "Informations personnelles",
    fullName: "Nom complet",
    email: "Email",
    phone: "Téléphone",
    address: "Adresse",
    city: "Ville",
    country: "Pays",
    passwordManagement: "Gestion du mot de passe",
    currentPassword: "Mot de passe actuel",
    enterCurrentPassword: "Entrez votre mot de passe actuel",
    newPassword: "Nouveau mot de passe",
    enterNewPassword: "Entrez votre nouveau mot de passe",
    confirmNewPassword: "Confirmer le nouveau mot de passe",
    confirmNewPasswordPlaceholder: "Confirmez votre nouveau mot de passe",
    updatePassword: "Mettre à jour le mot de passe",
    updating: "Mise à jour...",
    passwordSecurity: "Sécurité du mot de passe",
    passwordSecurityDesc1: "Utilisez au moins 6 caractères",
    passwordSecurityDesc2: "Mélangez lettres, chiffres et symboles",
    passwordSecurityDesc3: "Évitez les informations personnelles",
    learningStats: "Statistiques d'apprentissage",
    enrolledCoursesCount: "Cours inscrits",
    inProgressCourses: "Cours entamés",
    completedCourses: "Cours terminés",
    myCourses: "Mes cours",
    myCertificates: "Mes certificats",
    loadingCertificates: "Chargement des certificats...",
    certified: "Certifié",
    issuedOn: "Délivré le",
    downloadCertificate: "Télécharger le certificat",
    noCertificates: "Aucun certificat",
    noCertificatesDesc: "Terminez des cours pour obtenir vos certificats !",
    discoverCourses: "Découvrir les cours",
    adminDashboard: "Dashboard",
    adminDashboardDesc: "Vue d'ensemble",
    adminUsers: "Utilisateurs",
    adminUsersDesc: "Gestion des utilisateurs",
    adminCourses: "Cours",
    adminCoursesDesc: "Gestion des cours",
    adminAccessDesc: "Accédez aux outils d'administration de la plateforme.",
    notificationPreferences: "Préférences de notification",
    emailNotifications: "Notifications par email",
    emailNotificationsDesc: "Recevez des mises à jour par email",
    courseUpdates: "Mises à jour de cours",
    courseUpdatesDesc: "Notifications pour les nouveaux contenus",
    newCourses: "Nouveaux cours",
    newCoursesDesc: "Découvrez les nouveaux cours disponibles",
    studyReminders: "Rappels d'étude",
    studyRemindersDesc: "Rappels pour continuer vos cours",
    certificates: "Certificats",
    certificatesDesc: "Notifications pour vos certificats",
    generalSettings: "Paramètres généraux",
    language: "Langue",
    timezone: "Fuseau horaire",
    theme: "Thème",
    light: "Clair",
    dark: "Sombre",
    auto: "Automatique",
    profileUpdated: "Profil mis à jour avec succès",
    profileUpdateError: "Erreur lors de la mise à jour du profil",
    passwordMismatch: "Les mots de passe ne correspondent pas",
    passwordTooShort: "Le mot de passe doit contenir au moins 6 caractères",
    passwordUpdated: "Mot de passe mis à jour avec succès",
    passwordUpdateError: "Erreur lors de la mise à jour du mot de passe",
    certificateDownloadSuccess: "Certificat téléchargé avec succès",
    certificateDownloadError: "Erreur lors du téléchargement du certificat",
    certificateIdMissing: "ID du certificat manquant",
    invalidFile: "La réponse n'est pas un fichier valide"
  },
  verifyEmail: {
    verifying: "Vérification en cours",
    pleaseWait: "Veuillez patienter pendant la vérification de votre email...",
    emailVerified: "Email vérifié !",
    emailVerifiedDesc: "Votre email a été vérifié avec succès. Vous pouvez commencer.",
    startNow: "Commencer maintenant",
    verificationError: "Erreur de vérification",
    noToken: "Aucun token de vérification trouvé. Le lien peut être invalide ou expiré.",
    verificationFailed: "Impossible de vérifier votre email. Le lien peut être invalide ou expiré.",
    backToLogin: "Retour à la connexion",
    retry: "Réessayer",
    emailVerifiedSuccess: "Email vérifié avec succès",
    emailVerificationError: "Erreur de vérification de l'email"
  },
  resetPassword: {
    title: "Réinitialiser le mot de passe",
    invalidLink: "Lien invalide ou expiré. Veuillez redemander un lien de réinitialisation.",
    resetting: "Réinitialisation en cours...",
    resetSuccess: "Mot de passe réinitialisé avec succès. Redirection...",
    resetError: "Échec de la réinitialisation du mot de passe",
    newPasswordPlaceholder: "Nouveau mot de passe",
    confirmPasswordPlaceholder: "Confirmer le mot de passe",
    resetButton: "Réinitialiser",
    resettingButton: "Réinitialisation...",
    resetSuccessMessage: "Mot de passe réinitialisé avec succès"
  },
  modals: {
    emailVerification: {
      title: "Vérifiez votre email",
      message: "Nous avons envoyé un lien de vérification à :",
      clickLink: "Cliquez sur le lien dans l'email pour activer votre compte.",
      openMailbox: "Ouvrir ma boîte mail",
      resendEmail: "Renvoyer l'email",
      sending: "Envoi en cours...",
      emailResent: "Email renvoyé !",
      emailResentSuccess: "Email de vérification renvoyé !",
      important: "Important :",
      importantNote: "Vous devez vérifier votre email avant de pouvoir vous connecter."
    },
    coursePayment: {
      title: "Accès au cours",
      whatYouGet: "Ce que vous obtenez :",
      fullAccess: "Accès complet au contenu du cours",
      completionCertificate: "Certificat de completion",
      communitySupport: "Support communautaire",
      freeUpdates: "Mises à jour gratuites",
      lifetimeAccess: "Accès fermé après 6 mois d'inscription au module • Certificat inclus",
      securePayment: "Paiement sécurisé",
      securePaymentDesc: "Votre paiement est protégé par un cryptage SSL et traité de manière sécurisée.",
      generatingLink: "Génération du lien de paiement",
      generatingLinkDesc: "Veuillez patienter pendant que nous préparons votre paiement...",
      proceedToPayment: "Procéder au paiement",
      processing: "Traitement en cours...",
      instantPayment: "Paiement instantané • Accès immédiat",
      courseInfoMissing: "Informations du cours manquantes",
      paymentLinkError: "Erreur lors de la génération du lien de paiement",
      paymentError: "Erreur lors du traitement du paiement",
      redirectingToPayment: "Redirection vers le paiement..."
    },
    contentBlock: {
      addBlock: "Ajouter un bloc",
      editBlock: "Modifier le bloc",
      blockTitle: "Titre du bloc",
      blockTitlePlaceholder: "Titre du bloc",
      textContent: "Contenu textuel",
      textContentPlaceholder: "Saisissez le contenu textuel de votre bloc...",
      uploadImage: "Uploader une image",
      imageUploadDesc: "Glissez-déposez une image ou cliquez pour sélectionner un fichier",
      videoUrl: "URL de la vidéo",
      videoUrlPlaceholder: "https://youtube.com/watch?v=... ou https://vimeo.com/...",
      videoUrlDesc: "Supporte YouTube, Vimeo et autres plateformes vidéo",
      assignmentInstructions: "Instructions du devoir",
      assignmentPlaceholder: "Décrivez les instructions du devoir, les objectifs, les critères d'évaluation...",
      assignmentDesc: "Vous pourrez ajouter des indices et des exemples de sortie attendue plus tard",
      downloadInstructions: "Instructions de téléchargement",
      downloadPlaceholder: "Décrivez les fichiers à télécharger et les instructions...",
      downloadDesc: "Vous pourrez ajouter les fichiers plus tard via l'interface d'administration",
      quizQuestions: "Questions du quiz",
      question: "Question",
      questionType: "Type de question *",
      multipleChoice: "Choix multiple",
      singleChoice: "Choix unique",
      questionText: "Question *",
      questionPlaceholder: "Quelle est votre question ?",
      points: "Points pour cette question *",
      pointsDesc: "Nombre de points attribués si la question est correctement répondue",
      answerOptions: "Options de réponse *",
      option: "Option",
      multipleChoiceDesc: "Cochez toutes les bonnes réponses. Points partiels possibles : si une question vaut X points avec N bonnes réponses, chaque bonne réponse vaut X/N points.",
      singleChoiceDesc: "Sélectionnez la bonne réponse. Tous les points seront attribués si la réponse est correcte, 0 sinon.",
      addQuestion: "Ajouter la question",
      cancel: "Annuler",
      save: "Sauvegarder",
      add: "Ajouter le bloc"
    },
    moduleLock: {
      title: "Module verrouillé",
      mustValidatePrevious: "Vous devez valider le quiz du module précédent \"{{previousTitle}}\" pour accéder au module \"{{lockedTitle}}\".",
      moduleLocked: "Le module \"{{lockedTitle}}\" est verrouillé.",
      previousModuleToComplete: "Module précédent à compléter :",
      quizValidated: "✓ Quiz validé",
      bestScore: "Meilleur score : {{score}}% ({{status}})",
      quizNotStarted: "Quiz non commencé",
      close: "Fermer",
      goToPrevious: "Aller au module précédent",
      passed: "Réussi",
      failed: "Échoué"
    }
  },
  enrollmentGate: {
    connectToAccess: "Connectez-vous pour accéder à ce cours",
    createAccountOrLogin: "Créez un compte ou connectez-vous pour commencer votre apprentissage",
    free: "Gratuit",
    benefits: {
      fullAccess: "Accès complet au contenu du cours",
      trackProgress: "Suivez votre progression",
      completionCertificate: "Certificat de completion",
      lifetimeAccess: "Accès fermé après 6 mois d'inscription au module"
    },
    createAccount: "Créer un compte",
    alreadyHaveAccount: "J'ai déjà un compte",
    termsAcceptance: "En continuant, vous acceptez nos conditions d'utilisation",
    courseFree: "Cours gratuit",
    later: "Plus tard",
    enrollInCourse: "S'inscrire au cours",
    enrolling: "Inscription...",
    enrollmentSuccess: "Vous êtes maintenant inscrit à \"{{courseTitle}}\" !",
    enrollmentError: "Erreur lors de l'inscription. Veuillez réessayer."
  },
  footer: {
    description: "Votre nouvelle plateforme d'apprentissage en ligne.",
    emailPlaceholder: "Votre email",
    courses: "Cours",
    webDevelopment: "Développement Web",
    design: "Design",
    dataScience: "Data Science",
    entrepreneurship: "Entrepreneuriat",
    platform: "Plateforme",
    about: "À propos",
    contact: "Contact",
    blog: "Blog",
    help: "Aide",
    legal: "Légal",
    terms: "Conditions",
    privacy: "Confidentialité",
    cookies: "Cookies",
    copyright: "© {{year}} AY Solutions Academy. Tous droits réservés."
  },
  comments: {
    title: "Commentaires",
    comments: "commentaires",
    writeComment: "Écrivez votre commentaire...",
    post: "Publier",
    loginToComment: "Connectez-vous pour commenter",
    loginRequired: "Vous devez être connecté pour effectuer cette action",
    noComments: "Aucun commentaire pour le moment. Soyez le premier à commenter !",
    sortRecent: "Plus récents",
    sortOldest: "Plus anciens",
    sortMostLiked: "Plus aimés",
    reply: "Répondre",
    replies: "réponses",
    writeReply: "Écrivez votre réponse...",
    noReplies: "Aucune réponse",
    edited: "modifié",
    pinned: "Épinglé",
    confirmDelete: "Êtes-vous sûr de vouloir supprimer ce commentaire ?",
    page: "Page",
    filters: "Filtres",
    advancedFilters: "Filtres avancés",
    clearFilters: "Effacer les filtres",
    all: "Tous",
    filterReplies: "Réponses",
    withReplies: "Avec réponses",
    withoutReplies: "Sans réponses",
    filterPinned: "Épinglés",
    pinnedOnly: "Épinglés uniquement",
    filterEdited: "Modifiés",
    editedOnly: "Modifiés uniquement",
    minLikes: "Minimum de likes",
    minLikesPlaceholder: "Ex: 5",
    filterAuthor: "Auteur",
    authorIdPlaceholder: "ID de l'auteur",
    sortRelevant: "Pertinence"
  },
  webinars: {
    title: "Webinaires",
    subtitle: "Découvrez nos webinaires et inscrivez-vous",
    searchPlaceholder: "Rechercher un webinaire...",
    filters: {
      all: "Tous",
      upcoming: "À venir",
      ongoing: "En cours",
      completed: "Terminés"
    },
    status: {
      upcoming: "À venir",
      ongoing: "En cours",
      completed: "Terminé",
      unknown: "Non défini"
    },
    registered: "Inscrit",
    draft: "Brouillon",
    full: "Complet",
    notFound: "Webinaire introuvable",
    notFoundDesc: "Le webinaire demandé n'existe pas ou n'est plus disponible.",
    backToList: "Retour aux webinaires",
    noWebinars: "Aucun webinaire disponible",
    loginPrompt: "Connectez-vous pour vous inscrire aux webinaires",
    pagination: "Page",
    details: {
      title: "Informations",
      description: "Description",
      minutes: "minutes",
      registered: "inscrit(s)",
      max: "max"
    },
    noDescription: "Aucune description disponible.",
    register: "S'inscrire au webinaire",
    registering: "Inscription...",
    cancelRegistration: "Annuler l'inscription",
    cancelling: "Annulation...",
    loginToRegister: "Se connecter pour s'inscrire",
    joinMeeting: "Rejoindre la réunion",
    watchReplay: "Voir le replay",
    myWebinars: {
      title: "Mes Webinaires",
      subtitle: "Gérez vos inscriptions aux webinaires",
      upcoming: "À venir",
      completed: "Replays",
      noUpcoming: "Aucun webinaire à venir",
      noCompleted: "Aucun replay disponible",
      browseWebinars: "Découvrir les webinaires",
      instructions: {
        title: "Instructions",
        join: "Cliquez sur 'Rejoindre la réunion' pour accéder au webinaire",
        cancel: "Vous pouvez annuler votre inscription à tout moment"
      },
      replays: {
        title: "Replays disponibles",
        description: "Vous pouvez revoir les webinaires auxquels vous étiez inscrit"
      }
    }
  }
} as const

